import PageHero from "../components/PageHero";
import { Reveal, usePageMeta } from "../lib/motion";
import { PHONE, EMAIL, ADDRESS, SITE_DISCLAIMER } from "../data/content";

const CONTENT = {
  privacy: {
    title: "PRIVACY",
    highlight: "POLICY",
    updated: "Last updated: July 2026",
    sections: [
      {
        h: "Information We Collect",
        p: "When you submit an enquiry, eligibility check or contact form, we collect the details you provide — such as your name, phone number, email address, city, preferred destination and message — solely to respond to your request and provide consultation services.",
      },
      {
        h: "How We Use Your Information",
        p: "Your information is used to contact you regarding your enquiry, assess your requirements, and provide immigration and visa consultation. We do not sell, rent or share your personal information with third parties for marketing purposes.",
      },
      {
        h: "Data Security",
        p: "We take reasonable measures to protect the information you share with us. Access to enquiry data is restricted to authorized team members of The Trip World.",
      },
      {
        h: "Your Rights",
        p: `You may request access to, correction of, or deletion of your personal information at any time by contacting us at ${EMAIL} or ${PHONE}.`,
      },
      {
        h: "Contact",
        p: `For any privacy-related questions, contact The Trip World, ${ADDRESS}. Email: ${EMAIL}.`,
      },
    ],
  },
  terms: {
    title: "TERMS &",
    highlight: "CONDITIONS",
    updated: "Last updated: July 2026",
    sections: [
      {
        h: "Nature of Services",
        p: "The Trip World provides immigration and visa consultancy services, including consultation, documentation guidance and application assistance. We are a private consultancy and are not a government body, embassy or immigration authority.",
      },
      {
        h: "No Guarantee of Outcome",
        p: "Visa and immigration decisions are made solely by the relevant immigration authorities. The Trip World does not and cannot guarantee visa approval, processing times or any specific outcome.",
      },
      {
        h: "Accuracy of Information",
        p: "Content on this website is provided for general information. Immigration rules change frequently; visitors should verify current requirements through official government sources before making decisions.",
      },
      {
        h: "Client Responsibilities",
        p: "Clients are responsible for providing accurate, complete and genuine information and documents. The Trip World is not liable for outcomes resulting from inaccurate or incomplete information provided by clients.",
      },
      {
        h: "Intellectual Property",
        p: "All content, branding and design on this website are the property of The Trip World and may not be reproduced without written permission.",
      },
      {
        h: "Contact",
        p: `Questions about these terms may be directed to ${EMAIL} or ${PHONE}.`,
      },
    ],
  },
  disclaimer: {
    title: "LEGAL",
    highlight: "DISCLAIMER",
    updated: "Last updated: July 2026",
    sections: [
      {
        h: "Consultancy Disclaimer",
        p: SITE_DISCLAIMER,
      },
      {
        h: "Preliminary Assessments",
        p: "Any eligibility check, assessment or consultation provided by The Trip World — online or in person — is a preliminary assessment only. It does not constitute a decision on any visa application and does not guarantee approval.",
      },
      {
        h: "Not Legal Advice",
        p: "Information on this website and provided during consultation is general guidance, not legal advice. For decisions with legal implications, please consult the relevant official authorities or a licensed legal professional in the destination country.",
      },
      {
        h: "External Links & Sources",
        p: "This website may reference official government sources. The Trip World is not affiliated with any government or immigration authority, and such references do not imply endorsement.",
      },
    ],
  },
};

const LegalPage = ({ type }) => {
  const doc = CONTENT[type] || CONTENT.privacy;
  usePageMeta(`${doc.title} ${doc.highlight}`.trim(), `${doc.title} ${doc.highlight} — The Trip World, Ahmadgarh, Punjab.`);

  return (
    <main data-testid={`legal-page-${type}`}>
      <PageHero eyebrow="LEGAL" title={doc.title} highlight={doc.highlight} description={doc.updated} />
      <section className="py-20 bg-navy-deep">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 space-y-10">
          {doc.sections.map((s, i) => (
            <Reveal key={s.h} delay={i * 0.05}>
              <h2 className="font-display text-xl font-bold text-gold mb-3">{s.h}</h2>
              <p className="text-slate-400 leading-relaxed text-sm sm:text-base">{s.p}</p>
            </Reveal>
          ))}
        </div>
      </section>
    </main>
  );
};

export default LegalPage;
